export const REQUEST_SET_DECLINED = 'REQUEST_SET_DECLINED'
export const REQUEST_SET_IS_WAITING = 'REQUEST_SET_IS_WAITING'
export const REQUEST_SET_PROCESSED = 'REQUEST_SET_PROCESSED'
